import React from "react";
import "./styles/styles.css";

function Overlay({ show }) {
  return <div className={`overlay${show ? "-show" : "-hidden"}`} />;
}

export default Overlay;
